import { Box, Button as MuiButton } from '@mui/material';

// core components
import ReceiptIcon from '@mui/icons-material/Receipt';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

import { makeStyles } from '@mui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/themePreviewStyle.js';
const useStyles = makeStyles(styles);

export default function ThemePreview(props) {
  const classes = useStyles();
  const { theme } = props;

  return (
    <GridContainer>
      <GridItem xs={12} lg={8}>
        <GridContainer>
          <Box
            sx={{
              ...styles.previewContainer,
              ...{ fontFamily: theme.fontFamily, marginRight: 10 },
            }}
          >
            <div
              style={{ minHeight: 30, background: `${theme.backgroundColor}` }}
            >
              {theme.headerVisible && (
                <div
                  style={{
                    ...styles.header,
                    ...{
                      background: `${theme.primaryColor}`,
                      color: `${theme.primaryContrastTextColor}`,
                    },
                  }}
                >
                  HEADER
                </div>
              )}
            </div>
            <GridItem
              xs={12}
              style={{ background: `${theme.backgroundColor}` }}
            >
              <Box sx={{ height: 300, paddingTop: '16px' }}>
                <h4
                  style={{
                    color: `${theme.textColor}`,
                    fontWeight: 'bold',
                    fontFamily: theme.fontFamily,
                  }}
                >
                  Header titles on different views
                </h4>
                <GridContainer>
                  <GridItem xs={12}>
                    <p
                      style={{
                        color: `${theme.textColor}`,
                      }}
                    >
                      Other texts in views
                    </p>
                  </GridItem>
                  <GridItem xs={12} lg={6}>
                    <Box
                      sx={{
                        ...styles.shadowed,
                        ...styles.totalsContainer,
                        ...{
                          color: `${theme.textColor}`,
                        },
                      }}
                    >
                      <p style={{ margin: 0 }}>Item 1</p>
                      <p style={{ margin: 0 }}>$29.99</p>
                    </Box>
                  </GridItem>
                  <GridItem xs={12} lg={1}></GridItem>
                  <GridItem xs={12} lg={5}>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...styles.secondaryButton,
                        ...{
                          background: `${theme.secondaryColor}`,
                          color: `${theme.secondaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Secondary button
                    </MuiButton>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...styles.secondaryButton,
                        ...{
                          background: `${theme.secondaryColor}`,
                          color: `${theme.secondaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Secondary button
                    </MuiButton>
                  </GridItem>
                  <GridItem xs={12} style={styles.actionButtonsContainer}>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...{
                          background: `${theme.tertiaryColor}`,
                          color: `${theme.tertiaryContrastTextColor}`,
                          marginRight: 10,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Cancel
                    </MuiButton>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...{
                          background: `${theme.primaryColor}`,
                          color: `${theme.primaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Accept
                    </MuiButton>
                  </GridItem>
                </GridContainer>
              </Box>
            </GridItem>
            <div
              style={{
                ...styles.footer,
                ...{
                  background: `${theme.primaryColor}`,
                  color: `${theme.primaryContrastTextColor}`,
                },
              }}
            >
              Footer elements and menu items
            </div>
          </Box>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} lg={4}>
        <GridContainer>
          <Box
            sx={{
              ...styles.previewContainer,
              ...{ fontFamily: theme.fontFamily, maxWidth: 260 },
            }}
          >
            <div
              style={{
                position: 'relative',
                minHeight: 30,
                background: `${theme.backgroundColor}`,
              }}
            >
              {theme.headerVisible && (
                <div
                  style={{
                    ...styles.header,
                    ...{
                      background: `${theme.primaryColor}`,
                      color: `${theme.primaryContrastTextColor}`,
                    },
                  }}
                >
                  HEADER
                </div>
              )}
              <div
                style={{
                  ...styles.shadowed,
                  ...styles.floatinButton,
                  ...{
                    color: `${theme.textColor}`,
                  },
                }}
              >
                <ReceiptIcon />
              </div>
            </div>
            <GridItem
              xs={12}
              style={{ background: `${theme.backgroundColor}` }}
            >
              <Box sx={{ height: 300, paddingTop: '16px' }}>
                <h4
                  style={{
                    color: `${theme.textColor}`,
                    fontWeight: 'bold',
                    fontFamily: theme.fontFamily,
                  }}
                >
                  Header titles on different views
                </h4>
                <GridContainer>
                  <GridItem xs={12}>
                    <p
                      style={{
                        color: `${theme.textColor}`,
                      }}
                    >
                      Other texts in views
                    </p>
                  </GridItem>
                  <GridItem xs={12} lg={1}></GridItem>
                  <GridItem xs={12}>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...styles.secondaryButton,
                        ...{
                          background: `${theme.secondaryColor}`,
                          color: `${theme.secondaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Secondary button
                    </MuiButton>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...styles.secondaryButton,
                        ...{
                          background: `${theme.secondaryColor}`,
                          color: `${theme.secondaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Secondary button
                    </MuiButton>
                  </GridItem>
                  <GridItem xs={12} style={styles.actionButtonsContainer}>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...{
                          background: `${theme.tertiaryColor}`,
                          color: `${theme.tertiaryContrastTextColor}`,
                          marginRight: 10,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Cancel
                    </MuiButton>
                    <MuiButton
                      style={{
                        ...styles.shadowed,
                        ...{
                          background: `${theme.primaryColor}`,
                          color: `${theme.primaryContrastTextColor}`,
                          fontFamily: theme.fontFamily,
                        },
                      }}
                    >
                      Accept
                    </MuiButton>
                  </GridItem>
                </GridContainer>
              </Box>
            </GridItem>
            <div
              style={{
                ...styles.footer,
                ...{
                  background: `${theme.primaryColor}`,
                  color: `${theme.primaryContrastTextColor}`,
                },
              }}
            >
              Footer elements and menu items
            </div>
          </Box>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}
